import Form from "./FormDialog";
import Message from "./MessageDialog";
import Warning from "./WarningDialog";
import EmailVerification from "./EmailVerificationDialog";
import PasswordChange from "./PasswordChangeDialog";
import FirstLoginPasswordReset from "./FirstLoginPasswordResetDialog";
import DeleteNote from "./DeleteNoteDialog";
import EducationDetail from "./EducationDetailDialog";

const Dialogs = { Form, Message, Warning, EmailVerification, PasswordChange, FirstLoginPasswordReset, DeleteNote, EducationDetail };
export default Dialogs;